<template>
  <div class="box-info">
    <div class="info-nav-left">
      <div class="left-top">
        <i class="iconfont iconfenlei1"></i>
      </div>
      <div class="nav-item" :class="{active:type===0}" @click="toInfo('/home/meetAdmin/meetList')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        一般双选会列表
      </div>
      <div class="nav-item" :class="{active:type===1}" @click="toInfo('/home/meetAdmin/meetList2')">
        <div class="icon-yuan1">
          <div class="icon-yuan2">
            <i class="iconfont iconliebiao"></i>
          </div>
        </div>
        实习双选会列表
      </div>
    </div>
    <div class="right">
      <router-view @setType="setType"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: "zwrAdmin",
    data() {
      return {
        type: '',
        zwNum:0
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      this.$store.state.topNav = 12
    },
    methods: {
      toInfo(path) {
        this.$router.push(path)
      },
      setType(type) {
        this.type = type
      },

    }
  }
</script>

<style scoped lang="scss">

</style>